export enum EScreenZone {
  TOP = 'top',
  BOTTOM = 'bottom',
  STUB = 'stub',
}
